// extracted by mini-css-extract-plugin
export default {"wrapper":"Calendar_wrapper__87DiJ"};